import React, { useRef, useState } from "react";
import forwardArrow from "../../../../assets/images/forwardArrow.svg";
import { Typography } from "@mui/material";
import romRightFlexion from "../../../../assets/images/romRightFlexion.png";
// import viewReport from "../../../../assets/images/viewReport.svg";
import "./romTestModule.scss";
import { useDispatch } from "react-redux";
import {
  HOW_TO_TEST_RIGHT_FLEXION,
  ROM_RIGHT_EXTENSION,
} from "../../../../routes/routerPath";
import { searchParams } from "../../../../utlis/helpers";
import { useNavigate } from "react-router-dom";
import { setVideoFile } from "../../../../state/actions/videoUploadAction";
import { infoPageItem } from "../../../../utlis/constants";
import FileUpload from "../videoSaved/FileUpload";
import UserDetailsHeader from "../../UserDetailsHeader";
import { pageLocale } from "../../../../utlis/locale";

const ROMRightFlexion = () => {
  const storedTest = JSON.parse(sessionStorage.getItem("testMModule"));
  const getTestDetails = storedTest.find((e) => e.moduleId === 5);
  const [showItem, setShowItem] = useState(true);
  const itemList = [...infoPageItem];
  const videoRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const getInfo = JSON.parse(sessionStorage.getItem("testDescription"));
  const { how_to_test, record_upload } = pageLocale("testinfo");
  const { testUploadAlert } = pageLocale("common");
  const { right_leg, knee_flexion, skip, right_flexion_desc } =
    pageLocale("rom");
  const videoHandler = (title) => {
    if (title === how_to_test) {
      navigate(HOW_TO_TEST_RIGHT_FLEXION + `${searchParams}`);
    }
  };
  const videoPickHandler = () => {
    sessionStorage.setItem("fromUpload", JSON.stringify(getTestDetails));
    videoRef.current.click();
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      dispatch(setVideoFile(file));
      setShowItem(false);
    }
  };

  return (
    <>
      <UserDetailsHeader>
        <div className="rom-block">
          <Typography className="title">{getInfo?.moduleName}</Typography>
          {showItem ? (
            <div className="rom-test-info-wrapper">
              <div className="rom-test-item-block">
                <Typography className="leg-title">{right_leg}</Typography>
                <Typography className="leg">1: {knee_flexion}</Typography>
                <img
                  src={romRightFlexion}
                  alt="rom-leftFlexion"
                  className="test-img"
                />
                <Typography className="test-description">
                  {right_flexion_desc}
                </Typography>
                {itemList.map((item, index) => {
                  return (
                    <div
                      className="item-wrapper"
                      key={index}
                      onClick={() => videoHandler(item?.title)}
                    >
                      <div className="item-name">
                        <img src={item.icon} alt="info" className="img" />
                        <Typography>{item.title}</Typography>
                      </div>
                      <div className="arrow">
                        <img src={forwardArrow} alt="forwardArrow" />
                      </div>
                    </div>
                  );
                })}
                <input
                  type="file"
                  accept="video/mp4"
                  ref={videoRef}
                  className="video-upload"
                  onChange={handleFileChange}
                />
                <div className="important-text">
                  <Typography
                    className="sub-info"
                    component="div"
                    dangerouslySetInnerHTML={{ __html: testUploadAlert }}
                  />
                </div>
                <div className="record-upload-btn">
                  <button className="button" onClick={() => videoPickHandler()}>
                    {record_upload}
                  </button>
                </div>
                <button
                  className="skip-btn"
                  onClick={() =>
                    navigate(ROM_RIGHT_EXTENSION + `${searchParams}`)
                  }
                >
                  {skip}
                </button>
              </div>
            </div>
          ) : (
            <FileUpload styleChange={true} />
          )}
        </div>
      </UserDetailsHeader>
    </>
  );
};

export default ROMRightFlexion;
